import { Button, Container, Typography } from '@/ui-kit';
import { AvatarProfile } from './components/avatar-profile';
import { useAuth } from '@/store/useAuth';
import styles from './settings-profile.module.scss';
import { differenceInYearsResult } from '@/utils/difference-in-years-result';
import { BadgePremium } from '../badge-premium';
import { routesApp } from '@/constans/routes';
import { format } from 'date-fns';
import { IconTg, RemoderationIcon, ModerationPendingIcon, CheckIcon } from '@/assets/icons';
import { ru } from 'date-fns/locale';
import WebApp from '@twa-dev/sdk';
import { useEffect } from 'react';
import { ProfileActiveSection } from '../profile-active-section/profile-active-section';
import { useVibration } from '@/store/useVibration';
import { HalfDone } from '../half-done';
import { ProfileVerificationSection } from '../profile-verification-section/profile-verification-section';
import { PROFILE_CHANNEL_RECEIVED } from '@/utils/events';
import { getProfileNameAndAge } from '@/utils/msgs';

export const SettingsProfile: React.FC = () => {
    const userData = useAuth((state) => state.getUser());    
    const { setProfile } = useAuth((state) => state);

    const openLink = () => {
        WebApp.openTelegramLink('https://t.me/euphora_support')
    }

    const onProfileChannelReceived = (data: CustomEventInit) => {
        const payload = data.detail
        switch (payload.type) {
            case 'subscription_updated':
                setProfile({
                    ...payload.data.profile,
                })
                break;
        }
    }

    useEffect(() => {
        window.addEventListener(PROFILE_CHANNEL_RECEIVED, onProfileChannelReceived)
        return () => {
            window.removeEventListener(PROFILE_CHANNEL_RECEIVED, onProfileChannelReceived)
        };
    }, []);

    const { isVibrationEnabled } =
        useVibration(state => state);

    const onActivatePremiumClick = () => {
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    }

    return (
        <Container className={styles.container}>
            <AvatarProfile
                name={
                    getProfileNameAndAge(userData)
                }
                avatar={userData?.photos?.[0]?.thumb_url?.toString()} />

            {
                (
                    userData
                        ?.moderation_status
                        === 'change_required' &&
                    userData
                        ?.violations_resolved === false
                ) &&
                <div className={styles.remoderationCard}>
                    <div className={styles.remoderationCardContent}>
                        <RemoderationIcon className={styles.remoderationCardContentIcon} />
                        <Typography
                            fontWeight="semibold"
                            className={styles.remoderationCardContentTitle}
                            center>
                            Отредактируй свои данные, чтобы пройти модерацию
                        </Typography>
                        <Typography center>
                            После прохождения проверки твой профиль будет показываться в ленте и тебя смогут лайкать
                        </Typography>
                    </div>
                    <Button
                        typeColor='orange'
                        to={routesApp.profileEdit}
                        isLink
                        className={styles.remoderationCardBtn}>
                        Перейти в профиль
                    </Button>
                </div>
            }

            {
                userData?.state === 'half_done' &&
                <HalfDone />
            }

            {
                (
                    userData
                        ?.moderation_status
                        === 'change_required' &&
                    userData
                        ?.violations_resolved
                ) &&
                <div className={styles.remoderationCard}>
                    <div className={styles.remoderationCardContent}>
                        <ModerationPendingIcon className={styles.remoderationCardContentIcon} />
                        <Typography
                            fontWeight="semibold"
                            className={styles.remoderationCardContentTitle}
                            center>
                            Твоя анкета на проверке
                        </Typography>
                        <Typography center>
                            Сейчас проверяем твои данные, обычно это занимает немного времени
                        </Typography>
                    </div>
                </div>
            }

            <div className={styles.support}>
                <div>
                    <p>Поддержка</p>
                    <IconTg
                        width={25}
                        height={25}
                    />
                </div>
                <span onClick={openLink}>@euphora_support</span>
            </div>

            {!userData?.is_paid ? (
                <BadgePremium
                    title="Узнай, кому ты нравишься"
                    description="Смотрите анкеты тех, кому вы понравились и отвечайте взаимностью"
                    type="column">
                    <Button
                        className={styles.buttonBadge}
                        to={routesApp.subscription}
                        typeColor="orange"
                        isLink
                        onClick={onActivatePremiumClick}>
                        Активировать Premium
                    </Button>
                </BadgePremium>
            ) : (
                <div className={styles.activatedPremiumCard}>
                    <div className={styles.activatedPremiumCardMain}>
                        <Typography
                            fontWeight="bold"
                            variant="h2"
                            className={styles.activatedPremiumCardTitle}
                            center>
                            Euphora Premium
                        </Typography>
                        <Button className={styles.activatedPremiumCardBtn}>
                            {
                                [
                                    'Активна до',
                                    format(userData?.paid_till ? new Date(userData.paid_till) : new Date(), "d MMMM yyyy'г'", {
                                        locale: ru,
                                    })
                                ].join(' ')
                            }
                        </Button>
                    </div>
                    <ul className={styles.activatedPremiumCardBenefits}>
                        <li className={styles.activatedPremiumCardBenefit}>
                            <Typography
                                fontWeight="semibold"
                                variant="h6"
                                className={styles.activatedPremiumCardBenefitTitle}
                                center>
                                Просмотр лайков
                            </Typography>
                            <CheckIcon width={20} height={20} />
                        </li>
                        <li className={styles.activatedPremiumCardBenefit}>
                            <Typography
                                fontWeight="semibold"
                                variant="h6"
                                className={styles.activatedPremiumCardBenefitTitle}
                                center>
                                Повышенный приоритет
                            </Typography>
                            <CheckIcon width={20} height={20} />
                        </li>
                    </ul>
                </div>
            )}

            {
                userData?.verification_status === 'unverified' &&
                <ProfileVerificationSection />
            }
            
            <ProfileActiveSection />
        </Container>
    );
};
